import { toLower } from 'ramda';
import { toUpperFirst } from 'ramda-extension';

export const getSortingQueryString = sorting => {
	const { sortBy, sortDirection } = sorting ?? {};

	// NOTE: `sortDirection` will usually use `DESC` and `ASC` constants from `DataGridSortDirections`.
	return sortBy && sortDirection ? `$sortBy=${toUpperFirst(sortBy)} ${toLower(sortDirection)}` : '';
};
